export default __webpack_public_path__ + "assets/images/others/560e64598f11a07b5691ba29a5eb24dd.png";